import { render, staticRenderFns } from "./restore-password-form.vue?vue&type=template&id=c73c1f12"
import script from "./restore-password-form.vue?vue&type=script&lang=js"
export * from "./restore-password-form.vue?vue&type=script&lang=js"
import style0 from "./restore-password-form.vue?vue&type=style&index=0&id=c73c1f12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports